import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AssistanceHistoryResponse, AssistanceActiveResponse, AssistanceEndResponse, AssistanceDetail } from '../models/requests-response.model';

@Injectable({
  providedIn: 'root',
})
export class AssistanceService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  getAssistanceHistory(): Observable<AssistanceHistoryResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/history`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<AssistanceHistoryResponse>(url,{ headers });
  }

  getAssistanceActive(): Observable<AssistanceActiveResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/assistance/active`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<AssistanceActiveResponse>(url,{ headers });
  }

  getAssistanceEnd(): Observable<AssistanceEndResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/assistance/end`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<AssistanceEndResponse>(url,{ headers });
  }

  getAssistanceDetails(clExpediente:String): Observable<AssistanceDetail>{
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/file/${cognitoId}/details/${clExpediente}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<AssistanceDetail>(url,{ headers });
  }
}
